const capitalizeFirstLetter = (stringToChange: string) => (
  `${stringToChange[0].toUpperCase()}${stringToChange.slice(1)}`
);

export default capitalizeFirstLetter;
